import { useEffect, useState } from "react";
import QRScan from "../../components/qr_scan";
import { Controller, useForm } from "react-hook-form";
import CONFIG from "../../constanta/config";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import useUser from "../../hook/useUser";
import ReactSelect from "react-select";
import moment from "moment";

const FormThankyou = (props) => {
  useEffect(() => {
    setTimeout(() => {
      props?.ok()
    }, 500);
  }, [])
  return (
    <>
      <div className="space-y-5 px-5 py-10 bg-white rounded-md w-full md:w-1/2 transition-all">
        <div className="text-center font-bold mb-8">
        <div className="text-center text-2xl font-bold ">
            Hi, {props.user?.first_name}{" "}
            {props.user?.last_name !== "" ? " " + props.user?.last_name : ""}
          </div>
          <div className="text-center text-xl font-bold">
            {props.user?.departement}
          </div>
          <div className="text-center text-xl font-bold uppercase">
            {props.user?.other_detail}
          </div>
        </div>

        <div className="bg-green-500 w-full text-center py-5 text-white font-bold rounded">
          CHECKIN SUCCESS
        </div>

        {/* <div className="mx-auto flex justify-center items-center">
          <button
            type="button"
            onClick={() => props.ok()}
            className={`mt-10 w-[340px]  px-10 py-2 rounded-lg text-white font-bold bg-green-500  w-full text-center`}
          >
            OK
          </button>
        </div> */}
      </div>
    </>
  );
};

export default FormThankyou;
